const reviews = [
{
    id: 1,
    name: 'Isai Moyer',
    job: 'Fitness Enthusiast',
    image:
    "./assets/fake1.jpg",
    text:
    "I have been using the products from this company for over a year now, and I am beyond impressed with their quality and performance. Their customer service is also top-notch, always going above and beyond to help me with any questions or concerns I may have. I highly recommend this company to anyone looking for the best in fitness equipment!",
},
{
    id: 2,
    name: 'Amy Layne',
    job: 'Collegiate Weightlifter',
    image:
    "./assets/fake2.jpg",
    text:
    'I have never been a fitness enthusiast, but after trying out the products from this company, I have become a firm believer in their mission. Their focus on innovation and user experience has truly changed the game for me, making my workout routine much more enjoyable and effective. Thank you for changing my life!',
},
{
    id: 3,
    name: 'Peter Ramirez',
    job: 'Jiu-Jitsu Competitor',
    image:
    "./assets/fake3.jpg",
    text:
    'I was skeptical at first about trying a new fitness equipment brand, but I am so glad I took the leap of faith. The variety of products they offer is unparalleled, and their commitment to quality is evident in every piece. I have recommended this company to all my friends and family, and they all agree that it is the best choice for anyone looking to take their fitness to the next level.',
},
{
    id: 4,
    name: 'Justine Paulo',
    job: 'Mountain Biker',
    image:
    "./assets/fake4.jpg",
    text:
    'I have been in the fitness industry for over 20 years, and I can confidently say that this company is at the forefront of the industry. Their innovative approach to product design and development has made a huge impact on the market, and I am proud to be a customer. Keep up the amazing work!',
},
{
    id: 5,
    name: 'Neo Novak',
    job: 'Snowboard Enthusiast',
    image:
    "./assets/fake5.jpg",
    text:
    'I was looking for a new way to challenge myself and take my fitness to the next level, and I found exactly what I was looking for in this company. Their products are durable, reliable and make working out so much more fun. I am truly grateful for this company and the positive impact they have had on my life.',
},
];

export default reviews;
